import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'
import moment from 'moment'
import ConfirmDialogPreset from '@/components/autoImport/ConfirmDialogPreset'



const module = {
  state: {
    defaultDoBrowse: {
      searchInfo: {
        schedule_date: moment().startOf('isoWeek').format('YYYY-MM-DD'),
      },
      doBrowseStatus: 'init',
      studentSchedule: {},

      targetCenterNo: null,
    },
    selectedStudentData: null,
    studentSchedule: {},

    targetCenterNo: null,
  },

  getters: {

  },

  mutations: {},

  actions: {
    init ({ commit, state }, payload) {
      ApiUtils.postData({
        data: {
          dropdownData: {
            api: 'T3110LessonReportService.C50101_getDropdownData',
            input: payload,
          }
        }
      }).then((res) => {
        commit('setState', {
          dropdownData: res.dropdownData.output
        })
      })
    },
    async C20301_getStudentSchedule({ commit, state, dispatch }, payload) {
      return ApiUtils.postData({
        data: {
          C20301_getStudentSchedule: {
            api: 'T3010ScheduleService.C20301_getStudentSchedule',
            input: {
              ...state.searchInfo,
            },
          }
        }
      }).then((res) => {
        commit('setState', {
          studentSchedule: res.C20301_getStudentSchedule.output,
          doBrowseStatus: 'loaded',
        })
      })
    },
    async C20301_doAction({ commit, state, dispatch },{
      oldCenterNo,
      newCenterNo,
    }) {
      const centerList = window.vue.$store.state.Auth.m0110CenterGroup
      console.log('centerList', centerList,{
        oldCenterNo,
        newCenterNo,
      })
      const oldCenter = centerList.find(c => c.value === oldCenterNo)?.label || '旧センター'
      const newCenter = centerList.find(c => c.value === newCenterNo)?.label || '新センター'

      const result = await window.vue.$confirm({
        ...ConfirmDialogPreset.baseConfirm,
        text: `${oldCenter}から${newCenter}へ切り替えます。よろしいですか？`,
      })
      if (!result)
        return
      const input = {
        student_no: state.searchInfo.student_no,
        schedule_date: state.searchInfo.schedule_date,
        target_center_no: state.targetCenterNo,
      }
      const output = await ApiUtils.postData({
        data: {
          C20301_doAction: {
            api: 'T3010ScheduleService.C20301_doAction',
            input,
          }
        },
        databaseDiff:{
          tables: [
            't3010_schedule',
            't1010_student_basic'
          ]
        }
      })
      window.vue.$dialog.notify.success(`所属を更新しました。`)
      console.log(output)
      commit('setState', {
        _removeReactivity : true,
        doBrowseStatus: 'init',
      })
    },
    async C20301_doReset({ commit, state }) {
      commit('setState', {
        _removeReactivity : true,
        ...state.defaultDoBrowse,
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
